
const LOGO_PUBLIC_CACHE_BUST = "?v=7";


function getPublicAssetUrl(fileName) {
  const base = (typeof process !== "undefined" && process.env.PUBLIC_URL ? process.env.PUBLIC_URL : "").replace(/\/$/, "");
  const path = fileName.startsWith("/") ? fileName : `/${fileName}`;
  return `${base}${path}${LOGO_PUBLIC_CACHE_BUST}`;
}

/**
 * قيمة `size` تُمرَّر لـ `<Logo />` كعرض بالـ px في الـ inline style.
 * صفحات تسجيل الدخول/التسجيل: مع `className="auth-logo-img"` لا يُمرَّر عرض ثابت من الـ JS
 * (العرض من `index.css`: جلسة الدخول/التسجيل → `.auth-card--session .auth-logo-area` → `--auth-logo-w`؛
 * استعادة كلمة المرور والتحقق من البريد وغيرها (كارت بدون `--session`) → `.auth-logo-area` الافتراضي).
 * أماكن أخرى بـ `!important` على الصورة (مثل `.welcome-plans-brand-logo`).
 * لضبط لوجو صفحة الخطط الأولى + مودال الترقية معاً: عدّل في `index.css` على `:root`
 * المتغيرات `--welcome-upgrade-brand-logo-w` و`--welcome-upgrade-brand-logo-clip` إلخ.
 */
const LOGO_SIDEBAR_MARK_EXPANDED = 118;
const LOGO_SIDEBAR_MARK_COLLAPSED = 52;
const LOGO_CENTER_CHAT_EMPTY = 548;
const LOGO_AUTH_DEFAULT = 268;
const LOGO_AUTH_VERIFY_EMAIL = 292;
const LOGO_AUTH_SECONDARY = 248;
const LOGO_UPGRADE_MODAL = 520;
const LOGO_WELCOME_MODAL = LOGO_UPGRADE_MODAL;
const LOGO_APP_BOOT_LOADER = 104;
const LOGO_AUTH_CALLBACK = 100;
const LOGO_SHARED_CHAT_LOADER = 88;
export {
  LOGO_APP_BOOT_LOADER,
  LOGO_AUTH_CALLBACK,
  LOGO_AUTH_DEFAULT,
  LOGO_AUTH_SECONDARY,
  LOGO_AUTH_VERIFY_EMAIL,
  LOGO_CENTER_CHAT_EMPTY,
  LOGO_PUBLIC_CACHE_BUST,
  LOGO_SHARED_CHAT_LOADER,
  LOGO_SIDEBAR_MARK_COLLAPSED,
  LOGO_SIDEBAR_MARK_EXPANDED,
  LOGO_UPGRADE_MODAL,
  LOGO_WELCOME_MODAL,
  getPublicAssetUrl
};
